module.exports = __webpack_public_path__ + "assets/img/icon7.8a8a84ff.png";